import { Box } from '@mui/material';
import React from 'react';

function ButtonContainer({ children, ...props }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      gap={2}
      mt={3}
      mb={1}
      {...props}>
      {children}
    </Box>
  );
}

export default ButtonContainer;
